import React from 'react';
import { BookOpen, Zap, Target, Brain, TrendingUp, CheckCircle } from 'lucide-react';
import { features } from '../data/mockData';

const iconMap = {
  BookOpen,
  Zap,
  Target,
  Brain,
  TrendingUp,
  CheckCircle
};

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Por que escolher nossos <span className="text-orange-500">Flashcards?</span>
          </h2>
          <p className="text-xl text-gray-600">
            Método comprovado que já aprovou milhares de concurseiros
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={index}
                className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-100 hover:border-orange-500 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="bg-gradient-to-br from-blue-900 to-blue-800 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg">
                  <IconComponent className="text-orange-400" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-blue-50 to-orange-50 rounded-2xl p-8 border-2 border-orange-200">
            <p className="text-2xl font-bold text-gray-900 mb-4">
              Pronto para transformar seus estudos?
            </p>
            <p className="text-gray-600 mb-6">
              Junte-se a milhares de aprovados que estudaram com o Direito em 5 Minutos
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('produtos');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              Ver Todos os Flashcards
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
